import { render } from "./JakDolaczyc.vue?vue&type=template&id=6866eab4&scoped=true"
import script from "./JakDolaczyc.vue?vue&type=script&lang=js"
export * from "./JakDolaczyc.vue?vue&type=script&lang=js"

import "./JakDolaczyc.vue?vue&type=style&index=0&id=6866eab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6866eab4"]])

export default __exports__